import CurateShuffleModal from './CurateShuffleModal';

export default CurateShuffleModal;
